import { PATCH, POST } from "../API"
export const editMessageForConversationApi = (conversationId, messageId, original_message, onSuccess, onError) => {
    let data = {
        original_message: original_message
    }
    PATCH(`/api/v1/chat/conversations/${conversationId}/messages/${messageId}`, data, onSuccess, onError)
}